import React from 'react';
import stylesPlain from './plain.module.css';

import Field from './Field';
import SelectInstance from '../../modal/selectinstance/SelectInstance';
import PopupMenu from '../popupmenu/PopupMenu';

import { getCurrentResource, getDefinedItem } from '../../util/tools';
import { IET_SET_VALUE } from '../../util/realm/instance';
import { performApiRequest, MASTER_LOAD_REF_API_URL } from '../../util/restapi';

import iconSelect from '../../assets/icons/png24x24/Search.png';
import iconClear from '../../assets/icons/png24x24/edit-clear.png';

class FieldReference extends Field {

	selectInstanceRvContext = {
		rateView: null,
		form: null,
		formTitle: null, 
		data: null
	};

	/*
		refNodes
		styles
			label
			divMain
			divEditTools
	*/
	constructor(props) {
		super(props);
		this.resource = getCurrentResource().components.plain.FieldReference;
		if( this.props.refNodes.length > 0 ) {
			let refNode = this.props.refNodes[0];
			this.selectInstanceRvContext.form = refNode.selectInstanceFormId;
			this.selectInstanceRvContext.formTitle = refNode.selectInstanceFormTitle;
			this.selectInstanceRvContext.explicitConditions = refNode.explicitConditions;
			this.selectInstanceRvContext.filtersInitData = refNode.filtersInitData;
		}
		this.state.value = this.field ? this.field.value : null;
		this.state.serviceValue = '';
		this.state.isSelectInstanceModalOpen = false;
	}
	
	handleInstanceChange = async (event) => {
		if( event.eventType == IET_SET_VALUE && event.field == this.field) {
			this.setState({ value: event.newValue });
		}
	}
	handleServiceValueChange = e => {
		this.setState({ serviceValue: e.target.value });
	};
	
	selectInstance = (refNode) => {
		console.log('selectInstance. refNode', refNode)
		if( refNode ) {
			this.selectInstanceRvContext.form = refNode.selectInstanceFormId;
			this.selectInstanceRvContext.formTitle = refNode.selectInstanceFormTitle;
			this.selectInstanceRvContext.explicitConditions = refNode.explicitConditions;
			this.selectInstanceRvContext.filtersInitData = refNode.filtersInitData;
		}
		this.setState({ isSelectInstanceModalOpen: true });
	};
	onInstanceSelected = async (ids) => {
		if( ids.length == 0 )
			return;
		let request = {
			id: ids[0]
		}
		let response = await performApiRequest(MASTER_LOAD_REF_API_URL, request);
		if( ! response.success ) {
			this.props.plain.app.showResponse( response );
			return;
		}
		this.closeSelectInstance();
		let objectRef = response.data;
		this.props.instance.setFieldValue( this.field, objectRef );
	}
	closeSelectInstance = () => {
		this.setState({ isSelectInstanceModalOpen: false });
	}
	clearValue = () => {
		this.props.instance.setFieldValue( this.field, null );
	}
	
	render() {
		let valueHtml = null;
		let editToolsHtml = null;
		let inputServiceHtml = null;
		let value = this.state.value; 
		if( value != null && value.id != null ) {
			let objectRefNode = null;
			for(let item of this.props.refNodes) {
				if( item.classId == '*' || item.classId == value.className ) {
					objectRefNode = item;
					break;
				}
			}
			if( objectRefNode == null ) {
				valueHtml = (<span>{value.card}</span>);
			} else {
				let url = objectRefNode.plainFormPath + '/' + value.id;
				valueHtml = (<a href={url}>{value.card}</a>);
			}
		} else {
			valueHtml = <span style={{fontWeight: 'bold', fontStyle: 'italic'}}>{this.resource.messageNotDefined}</span>;
		}
		
		if( ! this.props.readOnly ) {
			if( this.props.inputService ) {
				// TODO nputServiceHtml = ...
			}
			let propsDivEditTools = getDefinedItem(this.props, ['styles', 'divEditTools'], {});
			let divEditToolsStyle = Object.assign(
				{minWidth: '90px'},
				{...propsDivEditTools}
			); 
			editToolsHtml = (
				<div style={divEditToolsStyle}>
					{inputServiceHtml}
					<ButtonSelectInstance holder={this} />
					<button type='button' className={stylesPlain.buttonIcon} style={{marginLeft: '5px'}}
						title={this.resource.buttonClearTooltip} onClick={this.clearValue}
					>
						<img src={iconClear} />
					</button>
					<SelectInstance 
						isModalOpen={this.state.isSelectInstanceModalOpen} 
						closeModal={this.closeSelectInstance}
						title={this.selectInstanceRvContext.formTitle}
						onInstanceSelected={this.onInstanceSelected}
						rvContext = {this.selectInstanceRvContext}
					/>
				</div>
			);
		}
		
		let propsDivMain = getDefinedItem(this.props, ['styles','divMain'], {} );
		let divMainStyle = {...propsDivMain};
		divMainStyle.display = 'flex';
		if( ! divMainStyle.alignItems )
			divMainStyle.alignItems = 'center';
		return (
			<div style={divMainStyle}>
				{this.createLabel()}
				{valueHtml}
				{editToolsHtml}
			</div>
		)
	}
	
}

function ButtonSelectInstance({holder}) {
	let refNodes = holder.props.refNodes; 
	if( ! refNodes || refNodes.length == 0 ) {
		return null;
	} else if( refNodes.length == 1 ) {
		let disabled = ! holder.selectInstanceRvContext.form;
		return (
			<button type='button' className={stylesPlain.buttonIcon} style={{marginLeft: '10px'}}
				title={holder.resource.buttonSelectTooltip} onClick={ () => {holder.selectInstance(null)} }
				disabled={disabled}
			>
				<img src={iconSelect} />
			</button>
		);
	} else {
		let style = {};
		let button = {
			text: holder.resource.buttonSelect, 
			tooltip: holder.resource.buttonSelectTooltip, 
			icon: iconSelect
		};
		let menu = { items: [] };
		for(let refNode of refNodes) {
			menu.items.push( {
				title: refNode.selectInstanceFormTitle,
				method: () => { holder.selectInstance(refNode) }
			} )
		}
		return (
			<PopupMenu holder={holder} style={style} button={button} menu={menu} />
		);
	}
}

export default FieldReference;
